import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Navigation } from '../../../navigation/react-redux-nav';
import { setConnectedProduct } from '../../../store/ducks/connected-product';
import MuiRaisedButton from 'material-ui/RaisedButton';
import Icon, { NAMES } from '@ifit/react-icons';
import { blueGray80 } from '../../../theme/colors';
import styles from '../../../shared-styles';

import './unsupported-product.css';

export class UnsupportedProduct extends Component {
  render() {
    return (
      <div className="unsupported-product-component">
        <Navigation.Backward onClick={ this.props.handleCancel }>
          <Icon
            name={ NAMES.CLOSE }
            color={ blueGray80 }
            size={ 16 }
            unitSize="px"
          />
        </Navigation.Backward>
        <div className="unsupported-product-copy">
          <img src={ this.props.iconSrc } alt={ this.props.appName } />
          <h1>You need the { this.props.appName } app.</h1>
          <p>{ this.props.body }</p>
        </div>
        <MuiRaisedButton
          className="button"
          onClick={ this.props.handleContinue }
          label="Continue"
          primary={ true }
          fullWidth={ true }
          style={ styles.buttonStyle }
          buttonStyle={ styles.buttonBorderStyle }
          labelStyle={ styles.buttonLabelStyle }
        />
      </div>
    );
  }
}

UnsupportedProduct.propTypes = {
  appName: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
  handleContinue: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  iconSrc: PropTypes.string.isRequired
};

export default connect(
  null,
  dispatch => ({
    handleCancel: () => dispatch(setConnectedProduct('other'))
  })
)(UnsupportedProduct);
